import React, { useState, useEffect } from 'react';
import { getClientById } from '../../flux/actions/clientActions';
import { Container, Row, Col } from 'reactstrap';

import { connect } from 'react-redux';
import { ClientCardContainer, IClientCardReduxProps } from '../../types/interfaces';

import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LoadingPage from '../../pages/loading';

const ClientCardContainerComponent = ({ 
  getClientById,
  client
 }: ClientCardContainer) => {
  const history = useHistory();
  const alert = useAlert();
  const { info, loading } = client;

  let { id } = useParams();

  useEffect(() => {
    if(id !== undefined && id !== null && !isNaN(id) && id >= 0)
      getClientById(id);
  }, []);

  return loading ? <LoadingPage/> : (
    <>
      <Container><h2 className="title">Fiche Client</h2></Container>
      {info ? (
      <Container className="CardInfo">
        <Row>
          <Col xs="12" sm="6">
            <strong>ID Client : </strong>{info.id ? info.id : "-"}
          </Col>
          <Col xs="12" sm="6">
            <strong>  : </strong>
            
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            <strong>Nom : </strong>{info.NOM || "-"}
          </Col>
          <Col xs="12" sm="6">
            <strong>Prenom : </strong>{info.PRENOM || "-"}
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            <strong>PAGE EN CONSTRUCTION</strong>
          </Col>
        </Row>
        {info.OBSERVATION ? (
        <Row>
          <Col xs="12">
            <strong>Commentaire : </strong>{info.OBSERVATION}
          </Col>
        </Row>
        ) : null}
      </Container>
      ) : `ID ${id} non valide.`}
    </>
  );
};

const mapStateToProps = (state: IClientCardReduxProps) => ({
  client: state.client,
  auth: state.auth
});

export default connect(mapStateToProps, { getClientById })(ClientCardContainerComponent);
